import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { map, catchError } from 'rxjs/operators';
import { BackendService } from './backend.services';


@Injectable({
    providedIn: 'root'
})
export class SvgGeneratorService {
    constructor(private backendService: BackendService) { }

    /** Load a SVG to the registry from a URL. */
    public loadSvg(url: string): Observable<string> {

      // not sure if there should be a possibility to use name for server usage
      // so overriding it for now if provided
      // maybe should separate functionality for url and name use-cases

    return this.backendService.getSvg(url).pipe(
        map(svg => {
            return svg;
        }),
        catchError(_err => {
            throw new Error('Function not implemented.');
        })
        ) as Observable<string>;
    }
}
